import { Constants } from '@leverege/molten';
import AmplitudeRolesPlugin from "./AmplitudeRolesPlugin.js";
import AmplitudePageViewTrackingPlugin from "./AmplitudePageViewTrackingPlugin.js";
export default {
  install(molten) {
    molten.addPlugin(Constants.LOGGED_IN, AmplitudeRolesPlugin);
    molten.addPlugin(Constants.LOGGED_IN, AmplitudePageViewTrackingPlugin);
  }
};